const sceneObserver = subjects => {
  let backgroundSubject = subjects[1];

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const containedSection = subjects.find(subject =>
          entry.target.contains(subject.element)
        );
        if (containedSection) {
          let containedElement = containedSection.element.parentNode;

          if (containedSection.id !== 0) {
            backgroundSubject.switchScenes(containedSection, subjects);
          }

          if (!containedElement.classList.contains("active")) {
            containedElement.classList.add("active");
          }

          subjects.forEach(subject => {
            let element = subject.element.parentNode;
            if (
              element !== containedElement &&
              element.classList.contains("active")
            ) {
              element.classList.remove("active");
            }
          });
        }
      }
    });
  });

  const observedSections = document.querySelectorAll(".scene-switch");
  observedSections.forEach(section => {
    observer.observe(section);
  });
};

export default sceneObserver;
